import { Card } from '../types'

export function SerialiseCards(cards: Card[][]): string[] {
  return cards.map((_cards) => _cards.join(','))
}

export function DeserialiseCards(cards: string[]): Card[][] {
  return cards.map((commaCards) =>
    commaCards.split(',').map((card) => {
      if (card.startsWith('a') || card === 'x2') {
        return card
      }

      return Number(card)
    }),
  ) as Card[][]
}
